import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-4 pb-28 pt-10 text-center md:pb-10" data-id="element-153" data-mp="19ivlq3plplne">
      <p className="font-serif text-lg font-bold text-white" data-id="element-154" data-mp="206j3niyycbee">Sensory Clinical Route™</p>
      <p className="mt-2 text-sm text-white/70" data-id="element-155" data-mp="2f53dzjq9utht">© 2026 · Dr. Elowen Varelli – Sensory Clinical Route™. All rights reserved.</p>
      <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-white/60" data-id="element-156" data-mp="2a71rspxjue24">
        Educational resource for Occupational Therapists and Occupational Therapy students. Not a substitute for professional judgment, standardized assessment training, certification, diagnosis, or individualized clinical care.
      </p>
    </footer>;
}